module.exports = __webpack_public_path__ + "img/TG.237beb72.svg";